import { __spreadArrays as w } from "../../../tslib/tslib.es6.js";
import * as y from "react";
import { useState as A, useRef as L, useEffect as k } from "react";
import { hideOthers as T } from "../../../aria-hidden/dist/es2015/index.js";
import { InteractivityDisabler as b } from "./InteractivityDisabler.js";
import { focusHiddenMarker as M } from "./medium.js";
var g = function(n) {
  return "current" in n ? n.current : n;
};
function O(n) {
  var m = n.setLockProps, c = n.onEscapeKey, a = n.onClickOutside, s = n.shards, v = n.onActivation, l = n.onDeactivation, D = n.noIsolation, E = A(void 0), o = E[0], h = E[1], f = L(null), p = L(0);
  return y.useEffect(function() {
    var r = function(t) {
      t.defaultPrevented || (t.code === "Escape" || t.key === "Escape" || t.keyCode === 27) && c && c(t);
    }, e = function(t) {
      t.defaultPrevented || t.target === f.current || t instanceof MouseEvent && t.button !== 0 || s && s.map(g).some(function(d) {
        return d && d.contains(t.target) || d === t.target;
      }) || a && a(t);
    }, u = function(t) {
      e(t), p.current = t.touches.length;
    }, i = function(t) {
      p.current = t.touches.length;
    };
    if (o)
      return document.addEventListener("keydown", r), document.addEventListener("mousedown", e), document.addEventListener("touchstart", u), document.addEventListener("touchend", i), function() {
        document.removeEventListener("keydown", r), document.removeEventListener("mousedown", e), document.removeEventListener("touchstart", u), document.removeEventListener("touchend", i);
      };
  }, [o, a, c]), k(function() {
    if (o)
      return v && v(o), function() {
        l && l();
      };
  }, [!!o]), k(function() {
    var r = function() {
      return null;
    }, e = !1, u = function(t) {
      D || (r = T(w([t], (s || []).map(g)), document.body, M)), h(function() {
        return t;
      });
    }, i = function() {
      r(), e || h(null);
    };
    return m({
      onMouseDown: function(t) {
        f.current = t.target;
      },
      onTouchStart: function(t) {
        f.current = t.target;
      },
      onActivation: u,
      onDeactivation: i
    }), function() {
      e = !0, m(!1);
    };
  }, []), y.createElement(b, null);
}
export {
  O as Effect
};
//# sourceMappingURL=Effect.js.map
